import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KamonaRoutingModule } from './kamona-routing.module';
import { KamonaComponent } from './kamona.component';
import { OtpCountDownComponent } from './components/otp-count-down/otp-count-down.component';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { KamonaMaximizeMobileDialogComponent } from './components/kamona-overlay/kamona-overlay-dialog/kamona-maximize-dialog/kamona-maximize-mobile-dialog/kamona-maximize-mobile-dialog.component';
import { MobileDeviceRegistrationComponent } from './components/mobile-web-view/components/mobile-device-registration/mobile-device-registration.component';
import { BackNavigationButtonComponent } from './components/mobile-web-view/components/back-navigation-button/back-navigation-button.component';
import { PasswordInputBoxComponent } from './components/mobile-web-view/components/password-input-box/password-input-box.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { KamonaInputFieldComponent } from './components/kamona-input-field/kamona-input-field.component';
import { TimeLineDetailsComponent } from './components/mobile-web-view/components/time-line-details/time-line-details.component';
import { TimeLineProgressComponent } from './components/mobile-web-view/components/time-line-progress/time-line-progress.component';
import { UssdBoardComponent } from './components/ussd-board/ussd-board.component';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { KamonaPhoneNumberFieldComponent } from './components/kamona-phone-number-field/kamona-phone-number-field.component';
import { KamonaDateInputFieldComponent } from './components/kamona-date-input-field/kamona-date-input-field.component';
import { KamonaPasswordInputComponent } from './components/kamona-password-input/kamona-password-input.component';
import { KamonaSelectFieldComponent } from './components/kamona-select-field/kamona-select-field.component';
import { KamonaCarouselComponent } from './components/kamona-carousel/kamona-carousel.component';

import { KamonaUsernamePolicyComponent } from './components/kamona-username-policy/kamona-username-policy.component';
import { KamonaLayoutComponent } from './components/kamona-layout/kamona-layout.component';
import { KamonaKycBannerComponent } from './components/kamona-kyc-banner/kamona-kyc-banner.component';
import { KycModalBannerComponent } from './components/kamona-kyc-banner/modal/kyc-modal-banner/kyc-modal-banner.component';
import { KamonaOverlayDialogComponent } from './components/kamona-overlay/kamona-overlay-dialog/kamona-overlay-dialog.component';
import { MobileDialogTemplateComponent } from './components/kamona-overlay/kamona-overlay-dialog/kamona-dialog-template/mobile-dialog-template/mobile-dialog-template.component';
import { FormButtonTemplateComponent } from './components/kamona-reusable-template/dialog-button-template/form-button-template.component';
import { DesktopDialogTemplateComponent } from './components/kamona-overlay/kamona-overlay-dialog/kamona-dialog-template/desktop-dialog-template/desktop-dialog-template.component';
import { KamonaBasicMessageDialogComponent } from './components/kamona-overlay/kamona-overlay-dialog/kamona-message-dialog/kamona-basic-message-dialog.component';
import { KamonaMobileLayoutComponent } from './components/kamona-mobile-layout/kamona-mobile-layout.component';
import { KamonaRadioButtonComponent } from './components/kamona-radio-button/kamona-radio-button.component';
import { KamonaCounterInputComponent } from './components/kamona-counter-input/kamona-counter-input.component';
import { InitializationScreenComponent } from './components/initialization-screen/initialization-screen.component';
import { KamonaVideoPlayerComponent } from './components/kamona-video-player/kamona-video-player.component';
import { KamonaSearchDropDownComponent } from './components/kamona-search-drop-down/kamona-search-drop-down.component';
import { UtilitiesModule } from '../utilities/utilities.module';
import { KamonaCheckBoxComponent } from './components/kamona-check-box/moniepoint-check-box.component';
import { KamonaButtonComponent } from './components/kamona-custom-button/kamona-custom-button.component';
import { KamonaSwitchButtonComponent } from './components/kamona-switch-button/kamona-switch-button.component';
import { KamonaLoadingComponent } from './components/kamona-loading/kamona-loading.component';
import { KamonaNotificationMessageComponent } from './components/kamona-notification-message/kamona-notification-message.component';
import { KamonaNotificationDetailsComponent } from './components/kamona-notitification-details/kamona-notification-details.component';
import { KamonaDialogComponent } from './components/kamona-dialog/kamona-dialog.component';
import { KamonaFailureModalComponent } from './components/kamona-failure-modal/kamona-failure-modal.component';
import { KamonaSuccessModalComponent } from './components/kamona-success-modal/kamona-success-modal.component';
import { KamonaPendingModalComponent } from './components/kamona-pending-modal/kamona-pending-modal.component';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TranslateModule } from '@ngx-translate/core';
import { LeanIconsModule } from '../lean-icons/lean-icons.module';
import { KamonaCustomErrorDisplayComponent } from './components/kamona-custom-error-display/kamona-custom-error-display.component';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { KamonaCollapseComponent } from './components/kamona-summary-dropdown/kamona-collapse.component';
import { KamonaOtpComponent } from './components/kamona-otp/kamona-otp.component';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { OtpModalBoardMobileComponent } from './components/otp-modal-board-mobile/otp-modal-board-mobile.component';
import { CustomMetaMapButtonComponent } from './components/custom-meta-map-button/custom-meta-map-button.component';
import { MetaMapVerificationDirective } from './directives/meta-map-verification.directive';
import { KamonaTimelineComponent } from './components/kamona-timeline/kamona-timeline.component';
import { KamonaMainAppLayoutComponent } from './components/kamona-main-app-layout/kamona-main-app-layout.component';
import { BusinessNameDetailsComponent } from './components/business-name-details/business-name-details.component';
import { KamonaSmileIdComponent } from './components/kamona-smile-id/kamona-smile-id.component';
import { SignUpV3HeaderComponent } from './components/sign-up-v3-header/sign-up-v3-header.component';
import { KamonaNumberPadComponent } from './components/kamona-number-pad/kamona-number-pad.component';
import { KamonaOtpWidgetComponent } from './components/kamona-otp-widget/kamona-otp-widget.component';
import { MobileKamonaOtpWidgetComponent } from './components/kamona-otp-widget/partials/mobile-kamona-otp-widget/mobile-kamona-otp-widget.component';
import { WebKamonaOtpWidgetComponent } from './components/kamona-otp-widget/partials/web-kamona-otp-widget/web-kamona-otp-widget.component';
import { KamonaPasswordWidgetComponent } from './components/kamona-password-widget/kamona-password-widget.component';
import { MobileKamonaPasswordWidgetComponent } from './components/kamona-password-widget/partials/mobile-kamona-password-widget/mobile-kamona-password-widget.component';
import { WebKamonaPasswordWidgetComponent } from './components/kamona-password-widget/partials/web-kamona-password-widget/web-kamona-password-widget.component';
import { KamonaPasscodeWidgetComponent } from './components/kamona-passcode-widget/kamona-passcode-widget.component';
import { MobileKamonaPasscodeWidgetComponent } from './components/kamona-passcode-widget/partials/mobile-kamona-passcode-widget/mobile-kamona-passcode-widget.component';
import { WebKamonaPasscodeWidgetComponent } from './components/kamona-passcode-widget/partials/web-kamona-passcode-widget/web-kamona-passcode-widget.component';
import { KamonaMessageModalComponent } from './components/kamona-message-modal/kamona-message-modal.component';
import { KamonaProgressModalComponent } from './components/kamona-progress-modal/kamona-progress-modal.component';
import { MobileKamonaMessageModalComponent } from './components/kamona-message-modal/partials/mobile-kamona-message-modal/mobile-kamona-message-modal.component';
import { WebKamonaMessageModalComponent } from './components/kamona-message-modal/partials/web-kamona-message-modal/web-kamona-message-modal.component';
import { KamonaStepperComponent } from './components/kamona-stepper/kamona-stepper.component';
import { MobileKamonaStepperComponent } from './components/kamona-stepper/partials/mobile-kamona-stepper/mobile-kamona-stepper.component';
import { WebKamonaStepperComponent } from './components/kamona-stepper/partials/web-kamona-stepper/web-kamona-stepper.component';
import { KamonaResentOtpModalComponent } from './components/kamona-resent-otp-modal/kamona-resent-otp-modal.component';
import { MobileKamonaResentOtpModalComponent } from './components/kamona-resent-otp-modal/partials/mobile-kamona-resent-otp-modal/mobile-kamona-resent-otp-modal.component';
import { WebKamonaResentOtpModalComponent } from './components/kamona-resent-otp-modal/partials/web-kamona-resent-otp-modal/web-kamona-resent-otp-modal.component';
import { KamonaIdVerificationComponent } from './components/kamona-id-verification/kamona-id-verification.component';
import { MobileKamonaIdVerificationComponent } from './components/kamona-id-verification/partials/mobile-kamona-id-verification/mobile-kamona-id-verification.component';
import { WebKamonaIdVerificationComponent } from './components/kamona-id-verification/partials/web-kamona-id-verification/web-kamona-id-verification.component';
import { KamonaLivelinessWidgetComponent } from './components/kamona-liveliness-widget/kamona-liveliness-widget.component';
import { MobileKamonaLivelinessWidgetComponent } from './components/kamona-liveliness-widget/partials/mobile-kamona-liveliness-widget/mobile-kamona-liveliness-widget.component';
import { WebKamonaLivelinessWidgetComponent } from './components/kamona-liveliness-widget/partials/web-kamona-liveliness-widget/web-kamona-liveliness-widget.component';
import { KamonaMessageWidgetComponent } from './components/kamona-message-widget/kamona-message-widget.component';
import { MobileKamonaMessageWidgetComponent } from './components/kamona-message-widget/partials/mobile-kamona-message-widget/mobile-kamona-message-widget.component';
import { WebKamonaMessageWidgetComponent } from './components/kamona-message-widget/partials/web-kamona-message-widget/web-kamona-message-widget.component';
import { KamonaTimeFormatPipe } from './pipes/kamona-time-format.pipe';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { AutoAddressApprovalComponent } from './components/auto-address-approval/auto-address-approval.component';
import { WebAutoAddressApprovalComponent } from './components/auto-address-approval/partials/web-auto-address-approval/web-auto-address-approval.component';
import { MobileAutoAddressApprovalComponent } from './components/auto-address-approval/partials/mobile-auto-address-approval/mobile-auto-address-approval.component';
import { KamonaSearchInputComponent } from './components/kamona-search-input/kamona-search-input.component';
import { AsyncLivelinessStatusComponent } from './components/async-liveliness-status/async-liveliness-status';
import { KamonaSearchDropDownV2Component } from './components/kamona-search-drop-down-v2/kamona-search-drop-down-v2.component';
import { KamonaMapPlaceholderComponent } from './components/kamona-map-placeholder/kamona-map-placeholder.component';
import { KamonaMapComponent } from './components/kamona-map/kamona-map.component';
import { KamonaCustomMapComponent } from './components/kamona-custom-map/kamona-custom-map.component';
import { AddressRevalidationComponent } from './components/address-revalidation/address-revalidation.component';
import { UploadProofOfAddressComponent } from './components/address-revalidation/upload-proof-of-address/upload-proof-of-address.component';
import { UpdateCurrentAddressComponent } from './components/address-revalidation/update-current-address/update-current-address.component';
import { SubmittedAddressComponent } from './components/address-revalidation/submitted-address/submitted-address.component';
import { ResidentialAddressSameAsBusinessComponent } from './components/address-revalidation/residential-address-same-as-business/residential-address-same-as-business.component';
import { ProofOfAddressFormComponent } from './components/address-revalidation/proof-of-address-form/proof-of-address-form.component';
import { PlaceOfResidenceComponent } from './components/address-revalidation/place-of-residence/place-of-residence.component';
import { ManualLocationSearchComponent } from './components/address-revalidation/manual-location-search/manual-location-search.component';
import { LocationNotFoundComponent } from './components/address-revalidation/location-not-found/location-not-found.component';
import { EnterAddressManuallyComponent } from './components/address-revalidation/enter-address-manually/enter-address-manually.component';
import { CurrentAddressComponent } from './components/address-revalidation/current-address/current-address.component';
import { AllowLocationAccessComponent } from './components/address-revalidation/allow-location-access/allow-location-access.component';
import { AddressMismatchComponent } from './components/address-revalidation/address-mismatch/address-mismatch.component';
import { KamonaCustomImageUploaderComponent } from './components/custom-image-uploader/kamona-custom-image-uploader.component';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MobileTimelineTemplateV2Component } from './components/mobile-timeline-template-v2/mobile-timeline-template-v2.component';
import { WebTimelineTemplateV2Component } from './components/web-timeline-template-v2/web-timeline-template-v2.component';
import { NeedHelpSectionComponent } from './components/need-help-section/need-help-section.component';
import { NeedHelpDesktopComponent } from './components/need-help/partials/need-help-desktop/need-help-desktop.component';
import { CookieComponent } from './components/cookie/cookie.component';


@NgModule({
    declarations: [
        KamonaComponent,
        OtpCountDownComponent,
        KamonaMaximizeMobileDialogComponent,
        MobileDeviceRegistrationComponent,
        BackNavigationButtonComponent,
        PasswordInputBoxComponent,
        KamonaInputFieldComponent,
        TimeLineDetailsComponent,
        TimeLineProgressComponent,
        UssdBoardComponent,
        KamonaPhoneNumberFieldComponent,
        KamonaDateInputFieldComponent,
        KamonaPasswordInputComponent,
        KamonaSelectFieldComponent,
        KamonaCarouselComponent,
        KamonaUsernamePolicyComponent,
        KamonaLayoutComponent,
        KamonaKycBannerComponent,
        KycModalBannerComponent,
        KamonaOverlayDialogComponent,
        MobileDialogTemplateComponent,
        FormButtonTemplateComponent,
        DesktopDialogTemplateComponent,
        KamonaBasicMessageDialogComponent,
        KamonaMobileLayoutComponent,
        KamonaRadioButtonComponent,
        KamonaCounterInputComponent,
        InitializationScreenComponent,
        KamonaVideoPlayerComponent,
        KamonaSearchDropDownComponent,
        KamonaSearchDropDownV2Component,
        KamonaCheckBoxComponent,
        KamonaButtonComponent,
        KamonaSwitchButtonComponent,
        KamonaLoadingComponent,
        KamonaNotificationMessageComponent,
        KamonaNotificationDetailsComponent,
        KamonaOverlayDialogComponent,
        KamonaDialogComponent,
        KamonaFailureModalComponent,
        KamonaSuccessModalComponent,
        KamonaPendingModalComponent,
        KamonaCustomErrorDisplayComponent,
        KamonaCollapseComponent,
        KamonaOtpComponent,
        NeedHelpSectionComponent,
        NeedHelpDesktopComponent,
        OtpModalBoardMobileComponent,
        CustomMetaMapButtonComponent,
        MetaMapVerificationDirective,
        MobileTimelineTemplateV2Component,
        WebTimelineTemplateV2Component,
        KamonaTimelineComponent,
        KamonaMainAppLayoutComponent,
        BusinessNameDetailsComponent,
        KamonaSmileIdComponent,
        SignUpV3HeaderComponent,
        KamonaNumberPadComponent,
        KamonaOtpWidgetComponent,
        MobileKamonaOtpWidgetComponent,
        WebKamonaOtpWidgetComponent,
        KamonaPasswordWidgetComponent,
        MobileKamonaPasswordWidgetComponent,
        WebKamonaPasswordWidgetComponent,
        KamonaPasscodeWidgetComponent,
        MobileKamonaPasscodeWidgetComponent,
        WebKamonaPasscodeWidgetComponent,
        KamonaMessageModalComponent,
        KamonaProgressModalComponent,
        MobileKamonaMessageModalComponent,
        WebKamonaMessageModalComponent,
        KamonaStepperComponent,
        MobileKamonaStepperComponent,
        WebKamonaStepperComponent,
        KamonaResentOtpModalComponent,
        MobileKamonaResentOtpModalComponent,
        WebKamonaResentOtpModalComponent,
        KamonaIdVerificationComponent,
        MobileKamonaIdVerificationComponent,
        WebKamonaIdVerificationComponent,
        KamonaLivelinessWidgetComponent,
        MobileKamonaLivelinessWidgetComponent,
        WebKamonaLivelinessWidgetComponent,
        KamonaMessageWidgetComponent,
        MobileKamonaMessageWidgetComponent,
        WebKamonaMessageWidgetComponent,
        KamonaTimeFormatPipe,
        PrivacyComponent,
        AutoAddressApprovalComponent,
        WebAutoAddressApprovalComponent,
        MobileAutoAddressApprovalComponent,
        KamonaSearchInputComponent,
        AsyncLivelinessStatusComponent,
        KamonaMapPlaceholderComponent,
        KamonaMapComponent,
        KamonaCustomMapComponent,
        AddressRevalidationComponent,
        UploadProofOfAddressComponent,
        UpdateCurrentAddressComponent,
        SubmittedAddressComponent,
        ResidentialAddressSameAsBusinessComponent,
        ProofOfAddressFormComponent,
        PlaceOfResidenceComponent,
        ManualLocationSearchComponent,
        LocationNotFoundComponent,
        EnterAddressManuallyComponent,
        CurrentAddressComponent,
        AllowLocationAccessComponent,
        AddressMismatchComponent,
        KamonaCustomImageUploaderComponent,
        CookieComponent,
    ],
    exports: [
        OtpCountDownComponent,
        MobileDeviceRegistrationComponent,
        KamonaMaximizeMobileDialogComponent,
        KamonaInputFieldComponent,
        BackNavigationButtonComponent,
        TimeLineProgressComponent,
        TimeLineDetailsComponent,
        PasswordInputBoxComponent,
        UssdBoardComponent,
        KamonaPhoneNumberFieldComponent,
        KamonaDateInputFieldComponent,
        KamonaPasswordInputComponent,
        KamonaSelectFieldComponent,
        KamonaCarouselComponent,
        KamonaUsernamePolicyComponent,
        KamonaLayoutComponent,
        KamonaKycBannerComponent,
        FormButtonTemplateComponent,
        KamonaMobileLayoutComponent,
        KamonaRadioButtonComponent,
        KamonaCounterInputComponent,
        InitializationScreenComponent,
        KamonaOverlayDialogComponent,
        KamonaVideoPlayerComponent,
        KamonaSearchDropDownComponent,
        KamonaSearchDropDownV2Component,
        KamonaCheckBoxComponent,
        KamonaButtonComponent,
        KamonaSwitchButtonComponent,
        KamonaLoadingComponent,
        KamonaNotificationMessageComponent,
        KamonaNotificationDetailsComponent,
        KamonaDialogComponent,
        KamonaFailureModalComponent,
        KamonaSuccessModalComponent,
        KamonaPendingModalComponent,
        KamonaCustomErrorDisplayComponent,
        KamonaCollapseComponent,
        KamonaOtpComponent,
        NeedHelpSectionComponent,
        NeedHelpDesktopComponent,
        CustomMetaMapButtonComponent,
        MobileTimelineTemplateV2Component,
        WebTimelineTemplateV2Component,
        BusinessNameDetailsComponent,
        KamonaSmileIdComponent,
        KamonaNumberPadComponent,
        MobileKamonaPasswordWidgetComponent,
        KamonaOtpWidgetComponent,
        MobileKamonaOtpWidgetComponent,
        MobileKamonaPasscodeWidgetComponent,
        MobileKamonaMessageModalComponent,
        WebKamonaStepperComponent,
        WebKamonaOtpWidgetComponent,
        WebKamonaPasswordWidgetComponent,
        KamonaComponent,
        WebKamonaPasscodeWidgetComponent,
        MobileKamonaResentOtpModalComponent,
        WebKamonaIdVerificationComponent,
        MobileKamonaIdVerificationComponent,
        MobileKamonaLivelinessWidgetComponent,
        MobileKamonaMessageWidgetComponent,
        WebKamonaMessageWidgetComponent,
        WebKamonaLivelinessWidgetComponent,
        KamonaTimeFormatPipe,
        PrivacyComponent,
        AutoAddressApprovalComponent,
        WebAutoAddressApprovalComponent,
        MobileAutoAddressApprovalComponent,
        KamonaSearchInputComponent,
        AsyncLivelinessStatusComponent,
        KamonaMapPlaceholderComponent,
        KamonaMapComponent,
        KamonaCustomMapComponent,
        AddressRevalidationComponent,
        UploadProofOfAddressComponent,
        UpdateCurrentAddressComponent,
        SubmittedAddressComponent,
        ResidentialAddressSameAsBusinessComponent,
        ProofOfAddressFormComponent,
        PlaceOfResidenceComponent,
        ManualLocationSearchComponent,
        LocationNotFoundComponent,
        EnterAddressManuallyComponent,
        CurrentAddressComponent,
        AllowLocationAccessComponent,
        AddressMismatchComponent,
        CookieComponent
    ],
    imports: [
        CommonModule,
        KamonaRoutingModule,
        NzGridModule,
        FormsModule,
        NzInputModule,
        NzProgressModule,
        UtilitiesModule,
        NzLayoutModule,
        NzSelectModule,
        NzToolTipModule,
        NzIconModule,
        NzDatePickerModule,
        NzButtonModule,
        TranslateModule,
        LeanIconsModule,
        NzAlertModule,
        ReactiveFormsModule,
        NzCollapseModule,
        NzDividerModule,
        PdfViewerModule,
        // ReactiveFormsModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class KamonaModule {}
